import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import { canGoBackInPage } from './viewHistory.js'

// Android-Zurück (Taste oder Wischgeste):
//  1. offenes Fenster im Feed schließen (registrierter Handler)
//  2. innerhalb einer Seite einen Schritt zurück (Chat → Chatliste → Dashboard …)
//  3. von Unterseiten (Login-Masken, Dashboards, Datenschutz) zurück zum Feed
//  4. erst im Feed ohne offenes Fenster die App schließen
let feedHandler = null

/** Handler gibt true zurück, wenn er das Zurück selbst behandelt hat */
export function setBackHandler(fn) {
  feedHandler = fn
  return () => { if (feedHandler === fn) feedHandler = null }
}

export function initBackButton() {
  if (Capacitor.getPlatform() !== 'android') return

  App.addListener('backButton', () => {
    if (feedHandler?.()) return
    if (canGoBackInPage()) {
      window.history.back()
      return
    }
    if (window.location.pathname !== '/') {
      // replace: die Unterseite soll nicht im Verlauf bleiben
      window.location.replace('/')
      return
    }
    App.exitApp()
  })
}
